import { render, staticRenderFns } from "./ComAddassemblyAlert.vue?vue&type=template&id=a9ba7412&scoped=true&"
import script from "./ComAddassemblyAlert.vue?vue&type=script&lang=js&"
export * from "./ComAddassemblyAlert.vue?vue&type=script&lang=js&"
import style0 from "./ComAddassemblyAlert.vue?vue&type=style&index=0&id=a9ba7412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ba7412",
  null
  
)

export default component.exports